import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRefreshCw02 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.33301 9.33333C1.33301 9.33333 1.41389 9.8995 3.75703 12.2426C6.10018 14.5858 9.89917 14.5858 12.2423 12.2426C13.0725 11.4125 13.6085 10.3995 13.8505 9.33333M1.33301 9.33333V13.3333M1.33301 9.33333H5.33301M14.6663 6.66667C14.6663 6.66667 14.5855 6.10051 12.2423 3.75736C9.89917 1.41421 6.10018 1.41421 3.75703 3.75736C2.92685 4.58754 2.3908 5.60048 2.14889 6.66667M14.6663 6.66667V2.66667M14.6663 6.66667H10.6663",
		stroke: "currentColor",
		strokeWidth: 1.33333,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgRefreshCw02;
